export default __webpack_public_path__ + "static/media/heddons.b9566578.jpg";